import React from "react";
import styled from "styled-components";
import { useTranslate } from "@tolgee/react";
import { ReactComponent as CloseIcon } from "../../Assets/iconsv2/generic/closeBtn.svg";

const CallChatHeader = ({ callInfo, onClose, participantCount }) => {
  const { t } = useTranslate();

  return (
    <Container>
      <HeaderContent>
        <Title>{t("call_modal.call_chat")}</Title>
      </HeaderContent>
      
      <CloseButton onClick={onClose}>
        <CloseIcon />
      </CloseButton>
    </Container>
  );
};

export default CallChatHeader;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 16px;
  background: ${({ theme }) => theme.callComponent.participantsListBackground};
  border-bottom: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  min-height: 70px;
`;

const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled.h3`
  font-size: 18px;
  font-weight: 600;
  line-height: 22px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
`;

const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
  margin-left: auto;
  
  svg {
    height: 28px;
    width: 28px;
    color: ${({ theme }) => theme.menu.selectedOpionBackground};
    stroke: ${({ theme }) => theme.sidebar.borderColor};
  }
`;